// Import component scripts (auto-generated)
import './components.js';

// Import layout scripts (auto-generated)
import './layouts.js';

// Import post layout scripts (auto-generated)
import './post_layouts.js';

// Import detail content and sidebar block scripts (auto-generated)
import './detail_content.js';
import './sidebar.js';

// Import theme scripts
import './core.js';
import './header.js';
import './faq.js';
import './archive-filters.js';
import './lazy-load-images.js';
import './footer-reveal.js';
import './animations.js';
import './button-text-animation.js';
